import { render, staticRenderFns } from "./AddComment.vue?vue&type=template&id=64c22049&scoped=true"
import script from "./AddComment.vue?vue&type=script&lang=js"
export * from "./AddComment.vue?vue&type=script&lang=js"
import style0 from "./AddComment.vue?vue&type=style&index=0&id=64c22049&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c22049",
  null
  
)

export default component.exports